<h2 mat-dialog-title>
  <span>{{ dialogData.fileName || ('INBOX.WEBSITE_PREVIEW.PREVIEW_TITLE' | translate) }}</span>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="preview-container">
    <div class="alert-container" *ngIf="isSupported()">
      <glxy-alert
        type="info"
        [showClose]="false"
        [showAction]="true"
        [actionTitle]="'INBOX.WEBSITE_PREVIEW.VIEW_LIVE_SITE' | translate"
        [actionExternalLink]="liveUrlForAction()"
        icon="info"
      >
        {{ 'INBOX.WEBSITE_PREVIEW.SCRAPED_CONTENT_WARNING' | translate }}
      </glxy-alert>
    </div>

    <div class="iframe-container" *ngIf="safeFileUrl()">
      <iframe [src]="safeFileUrl()" class="html-preview" frameborder="0" title="File preview"> </iframe>
    </div>
    <div class="error-message" *ngIf="!dialogData.fileUrl">
      <mat-icon>error</mat-icon>
      <p>{{ 'INBOX.WEBSITE_PREVIEW.NO_FILE_ERROR' | translate }}</p>
    </div>
    <div class="error-message" *ngIf="dialogData.fileUrl && !isSupported()">
      <mat-icon>warning</mat-icon>
      <p>{{ 'INBOX.WEBSITE_PREVIEW.UNSUPPORTED_TYPE_ERROR' | translate }}</p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>
    {{ 'INBOX.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
